import React, { useState } from 'react';
import styles from './index.module.scss';
import { Track } from '../../../models/tracks/track';
import StatsSimple from '../StatsSimple';
import EmptyMealGroup from '../EmptyMealGroup';
import Button from '../../components/Button';
import MealGroup from '../MealGroup';
import NewMealGroupModal from '../NewMealGroupModal';
import { tracker } from '../../../services/tracker';
import FinishDayModal from '../FinishDayModal';
import { analyticsApi } from '../../../services/analytics';

type Props = {
  track: Track;
  onAddNewMealGroup: () => void;
  onFinishDay: () => void;
};

const TodayReport = (props: Props) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isFinishDayModalOpen, setIsFinishDayModalOpen] = useState<boolean>(
    false,
  );

  const forceUpdate: () => void = React.useState()[1].bind(null, {});

  const addMealGroup = async (mealGroupName: string) => {
    await tracker.addMeal(props.track._id, mealGroupName);
    props.onAddNewMealGroup();
    setIsModalOpen(false);
  };

  const finishDay = async () => {
    await tracker.finishDay();
    props.onAddNewMealGroup();
    setIsFinishDayModalOpen(false);
  };

  const onRemoveMeal = () => {
    forceUpdate();
  };

  return (
    <>
      <StatsSimple data={props.track.getStats()} />
      {props.track.mealGroups.map((mealGroup) => {
        if (mealGroup.meals.length) {
          return (
            <MealGroup
              key={mealGroup.key}
              trackId={props.track._id}
              mealGroup={mealGroup}
              onRemoveMeal={onRemoveMeal}
            />
          );
        }
        return (
          <EmptyMealGroup
            key={mealGroup.key}
            value={mealGroup.value}
            id={mealGroup._id}
            trackId={props.track._id}
          />
        );
      })}
      <div className={styles.button_group}>
        <Button type={'default'}
                onClick={() => {
                  setIsModalOpen(true)
                  analyticsApi.logEvent(
                    '',
                    'Action',
                    {},
                    'Add New Meal Clicked'
                  )
                }}
        >
          New Meal
        </Button>
        <Button type={'success'}
                onClick={() => {
                  setIsFinishDayModalOpen(true)
                  analyticsApi.logEvent(
                    '',
                    'Action',
                    {},
                    'Finish Day Clicked'
                  )
                }}
        >
          Finish Day
        </Button>
      </div>
      {isModalOpen && (
        <NewMealGroupModal
          onSave={addMealGroup}
          onCancel={() => setIsModalOpen(false)}
        />
      )}
      {isFinishDayModalOpen && (
        <FinishDayModal
          onFinish={finishDay}
          onCancel={() => setIsFinishDayModalOpen(false)}
        />
      )}
    </>
  );
};

export default TodayReport;
